import { t } from 'i18next';
import { Chip, Tooltip } from '@mui/material';
import { alpha, useTheme } from '@mui/material/styles';
import PublicIcon from '@mui/icons-material/Public';
import LockIcon from '@mui/icons-material/Lock';
import { bloxValues } from 'themes/constants';

// Dashboard Type Status Component
export default function DashboardTypeChip({ type }: { type: string }) {
  const theme = useTheme();
  const isPublic = type === 'system';

  const label = isPublic
    ? t('blox.dashboards.custom.type.public.label', 'Public')
    : t('blox.dashboards.custom.type.private.label', 'Private');

  const tooltip = isPublic
    ? t('blox.dashboards.custom.type.public.desc', 'Available to all users')
    : t('blox.dashboards.custom.type.private.desc', 'Only visible to you');

  const Icon = isPublic ? PublicIcon : LockIcon;
  const color = isPublic ? theme.palette.success.main : theme.palette.info.main;

  return (
    <Tooltip
      title={tooltip}
      placement="top"
    >
      <span>
        <Chip
          role="status"
          aria-label={label}
          icon={<Icon sx={{ fontSize: 16 }} />}
          label={label}
          size="small"
          variant="filled"
          sx={{
            px: 0.5,
            fontSize: bloxValues.smallFontSizeRem,
            textTransform: 'capitalize',
            fontWeight: theme.typography.fontWeightMedium,
            color,
            borderColor: color,
            backgroundColor: alpha(color, 0.12),
            '.MuiChip-icon': { color: 'inherit' },
          }}
        />
      </span>
    </Tooltip>
  );
}
